/**
 *  Returns an array with exceptions for the sentence beginning researcher.
 *  @returns {Array} The array filled with exceptions.
 *  */
export default function() {
	return [
		// Numbers 1-10:
		"jeden", "jedna", "jedno", "dwa", "dwie", "trzy", "cztery", "pięć", "sześć", "siedem", "osiem", "dziewięć", "dziesięć",
		// Demonstrative pronouns:
		"ta", "to", "ten", "te", "ci", "taki", "tacy", "taka", "taką", "takich", "takie", "takiego", "takiej", "takiemu",
		"takim", "takimi", "tamten", "tamta", "tamto", "tamci", "tamte", "tamtą", "tamtego", "tamtej", "tamtemu", "tamtych",
		"tamtym", "tamtymi", "tą", "tę", "tego", "tej", "temu", "tych", "tymi", "tym", "tak",
	];
}
